import { TenantData } from "../main";

import { initializeSentry } from "./sentry";

export { AppConfigSync } from "./appConfigSync";

/**
 * Runs all initializers for the app.
 * @param tenantData - The tenant data for the app.
 */
export const runInitializers = (tenantData: TenantData) => {
  initializeSentry(tenantData.name);
};
